import { QueryParams } from 'configs/qp';
import { rootStore } from 'stores/root';

export const useIsMobileApp = () => {
  return Boolean(rootStore.qpStore.paramsMap[QueryParams.isMobileApp]);
};
